export const VAULT_MAX_FILE_SIZE_BYTES = 50 * 1024 * 1024;

export type VaultUploadStatus =
  | "queued"
  | "initializing"
  | "uploading"
  | "finalizing"
  | "ready"
  | "failed";

export type VaultUploadContext = {
  orgId: string;
  vaultId: string;
  folderId: string;
};

export type VaultUploadItem = {
  id: string;
  context: VaultUploadContext;
  file: File;
  fileName: string;
  mimeType: string | null;
  sizeBytes: number;
  status: VaultUploadStatus;
  fileId: string | null;
  storageBucket: string | null;
  storageObjectPath: string | null;
  errorMessage: string | null;
  errorCode: "file_too_large" | null;
  createdAt: string;
  updatedAt: string;
  completedAt: string | null;
  attempt: number;
};
